const vip = {
  title: 'VIP',
  subTitle1: 'VIP nedir',
  subTitle2: 'VIP deneyimi',
  subTitle3: 'VIP geçerlilik süresi',
  subTitle4: 'VIP Yükseltme',
  subTitle5: 'VIP seviye koruması',
  subTitle6: 'VIP düşürme',
  subTitle7: 'VIP Deneyim puanları',
  content1:
    'VIP, uygulama içindeki özel bir kimliktir. VIP olmak, uygulama içinde birden fazla ayrıcalığın kilidini açabilir. VIP ne kadar yüksekse, o kadar çok ayrıcalık elde edebilirsiniz.',
  content2:
    'Uygulamada coin yükleyerek VIP deneyim puanı kazanabilirsiniz (1 coin = 1 VIP deneyimi). VIP deneyimi, VIP seviyenizi yükseltmek ve korumak için kullanılabilir. İade talep ederseniz, yükleme yoluyla kazandığınız tüm VIP deneyimi düşülür.',
  content3: 'Her VIP seviyesi, VIP elde ettiğiniz günden itibaren 60 gün geçerlidir.',
  content4:
    'VIP geçerlilik süresi boyunca VIP deneyiminiz daha yüksek seviye yükseltme gereksinimlerine ulaşırsa, VIP seviyeniz hemen yükseltilir, VIP deneyiminiz sıfırlanır ve VIP günleri yeniden hesaplanır.',
  content5:
    "VIP geçerlilik süresi boyunca VIP deneyiminiz seviye koruma gereksinimlerine ulaşırsa, VIP'iniz süresi dolduktan sonra otomatik olarak yenilenecektir.",
  content6:
    'VIP deneyiminiz seviye koruması ve yükseltme için yeterli değilse, VIP karşılık gelen seviyeye düşürülecektir.',
  table: {
    level: 'Seviye',
    totalRechargeCoins: 'Toplam Coin Yükleme',
    upgradeVipExp: 'Gerekli VIP deneyimi',
    maintainVipExp: 'VIP Koruma EXP',
  },
};

export default {
  vip,
};
